module.exports.Following = require("./collection.coffee")
module.exports.FollowButton = require("./view.coffee")
